
	import { Component, Vue, Watch } from 'vue-property-decorator';
	import NotesModal from '@/components/modals/NotesModal.vue';
	import { Base64 } from 'js-base64';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component({
		components: {}
	})
	export default class PDFButton extends Vue {
		private toggle = false;
		private creating = false;

		public text = '';
		public hide = false;
		public hideOn = ['Get Started', 'Landmark selection', '3D Scan', 'Results', 'Patients', 'Saved Rx List', 'Saved Rx', 'Scan settings'];

		@Watch('$route', { immediate: true, deep: true })
		onNavigation(val: any) {
			this.hide = !this.hideOn.includes(val.name);
		}

		disable() {
			return this.$state.order.ordering || this.creating;
		}

		activated() {
			this.hide = !this.hideOn.includes(this.$route.name as string);
		}

		private async open() {
			try {
				this.creating = true;
				const base64PDF = await this.$state._patient.preparePDF();
				let decodedBase = Base64.toUint8Array(base64PDF);
				const blob = new Blob([decodedBase], { type: 'application/pdf' });

				// @ts-ignore
				if (window.navigator.msSaveOrOpenBlob) {
					navigator.msSaveOrOpenBlob(blob, 'presc.pdf');
				} else {
					const link = document.createElement('a');
					link.style.display = 'none';
					document.body.appendChild(link);
					if (link.download !== undefined) {
						link.setAttribute('href', URL.createObjectURL(blob));
						link.setAttribute('download', 'presc.pdf');
						try {
							await this.$router.push(this.$router.currentRoute.path + '?id=' + this.$state._patient.userRecordID);
						} catch (e) {
							console.log(e);
						}
						link.click();
					} else {
						// what???
						// decodedBase = 'application/pdf' + decodedBase;
						// window.open(encodeURI(decodedBase));
					}
					document.body.removeChild(link);
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.creating = false;
			}
		}

		private cancel() {
			this.toggle = false;
		}

		private save() {
			this.$state._patient.patientUIData.notes = this.text;
			this.toggle = false;
		}
	}
